import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store';

interface LayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<LayoutProps> = ({ children }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);

  const handleLogout = () => {
    dispatch({ type: 'LOGOUT' });
    history.push('/');
  };

  return (
    <div className="app">
      <header className="header">
        <div className="container header-content">
          <Link to="/" className="logo">BookSocial</Link>
          <nav className="nav">
            <Link to="/books" className="nav-link">书库</Link>
            {isAuthenticated ? (
              <>
                {user?.role === 'admin' && (
                  <Link to="/admin" className="nav-link" style={{ color: '#ff4d4f' }}>
                    管理后台
                  </Link>
                )}
                <Link to={`/profile/${user?.id}`} className="nav-link">
                  {user?.username || '用户'}
                </Link>
                <button onClick={handleLogout} className="nav-link" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                  退出
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="nav-link">登录</Link>
                <Link to="/register" className="nav-link">注册</Link>
              </>
            )}
          </nav>
        </div>
      </header>
      <main className="main-content">
        <div className="container">
          {children}
        </div>
      </main>
      <footer className="footer">
        <div className="container">
          <p>
			© 2026 BookSocial - 电子图书社区 @一春  | 
			<a href="http://www.atqtmh.cn:65535"> D5JI复古游戏计划 </a> | 
			<a href="http://www.d5ji.net"> D5JI复古游戏计划（镜像） </a> | 
		  </p>
        </div>
      </footer>
    </div>
  );
};

export default MainLayout;
